import { formatShortDate } from 'core/utilities';
import type { CyclesResponse } from '../../@types';
import { checkIfCanChooseCycle } from './helpers';
import { checkIfCanBuyOnlyInER } from './helpers/check-if-can-buy-only-in-er';

export function cyclesPresenter({ data, isExtendedCapitation }: CyclesResponse) {
  return {
    cycles: data.length
      ? data.map((cycle) => ({
          currentCycle: cycle.cycleNumber,
          daysTotal: cycle.cycleLength,
          finalDate: formatShortDate(cycle.finalDate),
          initialDate: formatShortDate(cycle.initialDate),
          daysLeft: cycle.remainingDays,
          toleranceDays: cycle.toleranceDays,
          brand: cycle.brand,
          name: cycle.name,
        }))
      : [],
    canChooseCycle: checkIfCanChooseCycle(data),
    canBuyOnlyInER: checkIfCanBuyOnlyInER(data, isExtendedCapitation),
    flagIsExtendedCaptation: isExtendedCapitation,
    message: '',
    status: '',
  };
}
